function n(n, r, t) {
  if (void 0 === r) return n;
  switch (null == t ? 3 : t) {
    case 1:
      return function (t) {
        return n.call(r, t);
      };
    case 3:
      return function (t, u, e) {
        return n.call(r, t, u, e);
      };
    case 4:
      return function (t, u, e, c) {
        return n.call(r, t, u, e, c);
      };
  }
  return function () {
    return n.apply(r, arguments);
  };
}
export { n as default };